import { selectApplicationInfo } from "./selectApplicationInfo";

export const selectShowFormImmediate = state => selectApplicationInfo(state).show_frame_immediate || false;

